import { render, staticRenderFns } from "./CustomColumnChooser.vue?vue&type=template&id=643bf3ce&"
import script from "./CustomColumnChooser.vue?vue&type=script&lang=js&"
export * from "./CustomColumnChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports